const bottomBar = {
  editMode: "מצב עריכה",
  done: "סיום",
  pickSlot: "בחר פריט",
  clearSlot: "נקה סלוט",
  pages: "עמודים",
  widgets: "ווידג'טים",
  longPressToEdit: "לחיצה ארוכה לעריכה",
  sidebar: "תפריט",
  widgetPanel: "ווידג'טים",
  emptySlot: "ריק",
  editBottomBar: "ערוך סרגל תחתון",
  menu: "תפריט",
  more: "עוד",
  navigation: "ניווט",
  openMenu: "פתח תפריט",
  closeMenu: "סגור תפריט",
} as const;
export default bottomBar;
